export default "__VITE_ASSET__DHvZMLKE__"